import React, { useState, useEffect } from "react";
import axios from "axios";
import { getBaseURL } from "../../services/api";

const API_BASE = getBaseURL();
const getAdminHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("adminToken")}` });

const AppSettings = () => {
    // Admin pages use AdminToast via their own provider, not GlobalToast
    const [toast, setToast] = useState({ show: false, msg: "", type: "" });
    const showToast = (msg, type = "success") => {
        setToast({ show: true, msg, type });
        setTimeout(() => setToast({ show: false, msg: "", type: "" }), 3000);
    };
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [settings, setSettings] = useState({
        latest_version: "0.1.0",
        update_url: "",
        is_force_update: false,
        message: "A new version is available! Update now to continue playing."
    });

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            const res = await axios.get(`${API_BASE}/admin/settings`, { headers: getAdminHeaders() });
            if (res.data) setSettings(res.data);
        } catch (err) {
            console.error("Fetch settings error:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        setSaving(true);
        try {
            await axios.post(`${API_BASE}/admin/settings`, settings, { headers: getAdminHeaders() });
            showToast("App Settings updated successfully!", "success");
        } catch (err) {
            const errMsg = err.response?.data?.error || err.message;
            showToast("Failed: " + errMsg, "error");
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <div style={{ padding: 40, color: "white", textAlign: "center" }}>Loading Settings...</div>;

    return (
        <div style={{ minHeight: "100vh", background: "#0f1115", color: "white", padding: 24, fontFamily: "'Inter', sans-serif" }}>
            {/* Inline Toast */}
            {toast.show && (
                <div style={{ position: "fixed", bottom: 30, left: "50%", transform: "translateX(-50%)", background: toast.type === "success" ? "#22c55e" : "#ef4444", color: "white", padding: "14px 24px", borderRadius: 16, fontWeight: 700, zIndex: 99999, fontSize: 14 }}>
                    {toast.type === "success" ? "✅" : "❌"} {toast.msg}
                </div>
            )}
            <div className="max-w-2xl mx-auto">
                <div className="flex items-center gap-4 mb-8">
                    <button onClick={() => window.history.back()} className="bg-[#1e2128] p-3 rounded-xl border border-white/10 active:scale-90 transition-all">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M15 18l-6-6 6-6" /></svg>
                    </button>
                    <h1 className="text-2xl font-black uppercase tracking-widest italic">App Update Settings</h1>
                </div>

                <form onSubmit={handleSave} className="bg-[#1e2128] rounded-[32px] p-8 border border-white/5 shadow-2xl space-y-6">
                    <div>
                        <label className="text-[10px] font-black uppercase tracking-widest text-white/40 block mb-3 ml-1">Latest Version (Current: 0.1.0)</label>
                        <input 
                            type="text" 
                            className="w-full bg-[#0f1115] border border-white/10 rounded-2xl p-4 font-bold outline-none focus:border-pink-500 transition-all"
                            value={settings.latest_version}
                            onChange={e => setSettings({...settings, latest_version: e.target.value})}
                            placeholder="e.g. 1.0.5"
                        />
                    </div>

                    <div>
                        <label className="text-[10px] font-black uppercase tracking-widest text-white/40 block mb-3 ml-1">Update Download URL (APK Link)</label>
                        <input 
                            type="text" 
                            className="w-full bg-[#0f1115] border border-white/10 rounded-2xl p-4 font-bold outline-none focus:border-pink-500 transition-all"
                            value={settings.update_url}
                            onChange={e => setSettings({...settings, update_url: e.target.value})}
                            placeholder="https://winrox11.com/v1.0.5.apk"
                        />
                    </div>

                    <div>
                        <label className="text-[10px] font-black uppercase tracking-widest text-white/40 block mb-3 ml-1">Update Message</label>
                        <textarea 
                            rows="3"
                            className="w-full bg-[#0f1115] border border-white/10 rounded-2xl p-4 font-bold outline-none focus:border-pink-500 transition-all resize-none"
                            value={settings.message}
                            onChange={e => setSettings({...settings, message: e.target.value})}
                        />
                    </div>

                    <div className="flex items-center justify-between bg-[#0f1115] p-5 rounded-2xl border border-white/5">
                        <div>
                            <p className="text-sm font-bold">Force Update</p>
                            <p className="text-[10px] text-white/40 font-medium">Users cannot skip this update</p>
                        </div>
                        <label className="relative inline-flex items-center cursor-pointer">
                            <input type="checkbox" className="sr-only peer" checked={settings.is_force_update} onChange={e => setSettings({...settings, is_force_update: e.target.checked})} />
                            <div className="w-11 h-6 bg-gray-700 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-pink-500"></div>
                        </label>
                    </div>

                    <button 
                        type="submit" 
                        disabled={saving}
                        className="w-full bg-pink-500 hover:bg-pink-600 text-white py-5 rounded-2xl font-black uppercase tracking-widest transition-all active:scale-95 shadow-lg shadow-pink-500/20 disabled:opacity-50"
                    >
                        {saving ? "Saving..." : "Update Settings"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AppSettings;
